import React from 'react';
import {Divider} from '@material-ui/core';
import YouTube from 'react-youtube';
import { LIKE } from '../../../../constants/common';

import FavoriteIcon from '@material-ui/icons/Favorite';
import FavoriteBorderIcon from '@material-ui/icons/FavoriteBorder';
import { toTitleCase } from '../../../../helpers/helper';
import { getApplianceName } from '../../../../helpers/itemizationDataHelper';

export default function RecoDetails(props){
    const opts = {
        height: '390px',
        width: '60%'
      };
    const recoDetails = props.data.details;
    const recoMetaData = props.data.metaData;
    return(
        <>
        {props.data.failed || !recoDetails || !recoMetaData ? <div className="no-data">{props.translations["RECOMMENDATIONS.DETAILS_UNAVAILABLE"]}</div> :
        <div className="reco-details-content">
            <div className="reco-details-header" dangerouslySetInnerHTML={{ __html: recoDetails.recommendationTitle}}>
            </div>
            <Divider/>
            {
                recoDetails.recommendationImageURL ?
                <div className="reco-details-image-wrapper">
                    <img className="reco-details-image" src={recoDetails.recommendationImageURL} alt=""/>
                </div>
                : ''
            }

            <div className="reco-details-description"  dangerouslySetInnerHTML={{ __html: recoDetails.recommendationDescription}}>
            </div>

            {
                recoDetails.youtubeVideoId ?
                <div className="reco-details-video">
                    <YouTube videoId={recoDetails.youtubeVideoId} opts={opts}/>
                </div>
                : ''
            }
            {
                recoMetaData  ?
                <div className="likes-container">
                    { recoMetaData.recommendationFeedback.response === LIKE ?
                        <FavoriteIcon className="recommendations-likes"/> :
                        <FavoriteBorderIcon className="recommendations-likes" />
                    }
                    {recoMetaData.recommendationStatistics.countLike > 0 && (
                        <>
                            {recoMetaData.recommendationStatistics.countLike} {recoMetaData.recommendationStatistics.countLike > 1 ? props.translations["RECOMMENDATIONS.TIPS.LIKES"] : props.translations["RECOMMENDATIONS.TIPS.LIKE"]}
                        </>
                    )}
                </div>
            : ''
            }
            {
                props.ctaEnabled && recoMetaData.recommendationsMetaData.purchaseLinks && recoMetaData.recommendationsMetaData.purchaseLinks.length &&
                <div className="cta-wrapper">
                    <Divider className="divider"/>
                    <div className="cta-header">
                        {recoDetails.ctaDescription}
                    </div>
                    <div className="purchase-btn-wrapper">
                        {recoMetaData.recommendationsMetaData.purchaseLinks.map((item, index)=>(
                            <div key={index} className="purchase-btn" onClick={()=>props.openPurchaseLink(item.link)} data-toggle="tooltip" title={item.link}>
                                {item.logo ? <img src={item.logo} alt={item.name}/> : <div className="link-name">{toTitleCase(item.name)}</div>}
                            </div>
                        ))}
                    </div>
                </div>
            }
        </div>
        }
        </>
    )
}
